module.exports = __webpack_public_path__ + "img/bay_room-2.06ac5e6c.jpg";